import { useCourseModeration } from '../useCourseModeration'

/**
 * Бета-автор — автор без права публиковать в каталог (правило бэка: `canPublishToCatalog`).
 * Признак приходит с модерацией курса, поэтому читается в редакторе по id курса.
 * Пока ответа нет — `false`: «не знаем» ≠ «бета», ничего не прячем заранее.
 * Временные ограничения бета-авторов (AI-панель, отрисовка картинок) читают ТОЛЬКО его.
 */
export const useIsBetaAuthor = (courseId: number): boolean =>
  useCourseModeration(courseId).state?.canPublishToCatalog === false
